import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResourceService } from 'src/app/global/services/resource.service';
import { WEB_API } from 'src/app/global/services/web-api';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { SegmentoClienteDTO } from '../domain/dto/segmento-cliente.dto';
import { EstadosClientes } from '../domain/dto/estados-clientes.dto';
import { HistoricoCreditosResponse } from '../domain/dto/historico-creditos.dto';
import { InadimplenciaCliente, InadimplenciaContrato, InadimplenciaEvolucao,InadimplenciaFaixaAtraso,InadimplenciaKpis,InadimplenciaReincidente} from '../domain/dto/historico-inadiplencia.dto';
import { PagamentosPorClientes } from '../domain/dto/pagamentos-por-clientes.dto';
import { ParcelasPagasVencidas } from '../domain/dto/parcelas-pagas-vencidas.dto';
import { RenovacaoCredito } from '../domain/dto/renovacao-credito.dto';
import { RenovacaoEvolucaoMensal } from '../domain/dto/renovacao-evolucao-mensal.dto';
import { RenovacaoPorEstado } from '../domain/dto/renovacao-por-estado.dto';
import { RenovacaoRankingFrequencia } from '../domain/dto/renovacao-ranking-frequencia.dto';
import { RenovacaoClientesNaoRenovaram } from '../domain/dto/renovacao-clientes-nao-renovaram.dto';
import { RenovacaoAptos } from '../domain/dto/renovacao-aptos.dto';
import { RenovacaoContatados } from '../domain/dto/renovacao-contatados.dto';
import { RenovacaoEmNegociacao } from '../domain/dto/renovacao-em-negociacao.dto';
import { RenovacaoComparativoStatus } from '../domain/dto/renovacao-comparativo-status.dto';
import { CrescimentoBaseClientes } from '../domain/dto/crescimento-base-clientes.dto';
import { CrescimentoBaseClientesKpis } from '../domain/dto/crescimento-base-clientes-kpis.dto';
import { CrescimentoBaseClientesCidade } from '../domain/dto/crescimento-base-clientes-cidade.dto';
import { CrescimentoBaseClientesDistribuicaoSegmento } from '../domain/dto/crescimento-base-clientes-distribuicao-segmento.dto';
import { CrescimentoBaseClientesPrimeiraOperacao } from '../domain/dto/crescimento-base-clientes-primeira-operacao.dto';
import { CrescimentoBaseClientesInativoBloqueado } from '../domain/dto/crescimento-base-clientes-inativo-bloqueado.dto';
import { VolumeCreditoMensal } from '../domain/dto/volume-credito-mensal.dto';
import { ComparativosHistoricos } from '../domain/dto/comparativos-historicos.dto';
import { NovatosCobrancasRenovacoes } from '../domain/dto/novatos-cobrancas-renovacoes.dto';

@Injectable({
    providedIn: 'root',
})
export class NovoDashboardService extends ResourceService<SegmentoClienteDTO> {

    static RESOURCE = 'novo-dashboard';

    constructor(http: HttpClient) {
        super(http, `${WEB_API}`, NovoDashboardService.RESOURCE, null);
    }

    findAllSegmentosClientes(queryOptions: QueryOptions): Observable<SegmentoClienteDTO[]> {
        return this.httpClient.get<SegmentoClienteDTO[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/segmentos-atividade?${queryOptions.toQueryString()}`
        );
    }
    findAllEstadosClientes(queryOptions: QueryOptions): Observable<EstadosClientes[]> {
        return this.httpClient.get<EstadosClientes[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/estados-clientes?${queryOptions.toQueryString()}`
        );
    }
    findAllHistoricoCreditos(queryOptions: QueryOptions): Observable<HistoricoCreditosResponse> {
        return this.httpClient.get<HistoricoCreditosResponse>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/historico-cliente?${queryOptions.toQueryString(false)}`
        );
    }

    findInadimplenciaKpis(queryOptions: QueryOptions): Observable<InadimplenciaKpis> {
        return this.httpClient.get<InadimplenciaKpis>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/historico-inadimplencia-kpis?${queryOptions.toQueryString(false)}`
        );
    }

    findInadimplenciaEvolucao(queryOptions: QueryOptions): Observable<InadimplenciaEvolucao[]> {
        return this.httpClient.get<InadimplenciaEvolucao[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/historico-inadimplencia-evolucao?${queryOptions.toQueryString(false)}`
        );
    }

    findInadimplenciaFaixasAtraso(queryOptions: QueryOptions): Observable<InadimplenciaFaixaAtraso[]> {
        return this.httpClient.get<InadimplenciaFaixaAtraso[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/historico-inadimplencia-faixas-atraso?${queryOptions.toQueryString(false)}`
        );
    }

    findInadimplenciaRankingClientes(queryOptions: QueryOptions): Observable<InadimplenciaCliente[]> {
        return this.httpClient.get<InadimplenciaCliente[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/historico-inadimplencia-ranking-clientes?${queryOptions.toQueryString(false)}`
        );
    }

    findInadimplenciaContratos(queryOptions: QueryOptions): Observable<InadimplenciaContrato[]> {
        return this.httpClient.get<InadimplenciaContrato[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/historico-inadimplencia-contratos?${queryOptions.toQueryString(false)}`
        );
    }

    findInadimplenciaReincidentes(queryOptions: QueryOptions): Observable<InadimplenciaReincidente[]> {
        return this.httpClient.get<InadimplenciaReincidente[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/historico-inadimplencia-reincidentes?${queryOptions.toQueryString(false)}`
        );
    }

    findEstadosInadimplencia(): Observable<string[]> {
        return this.httpClient.get<string[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/historico-inadimplencia/estados`
        );
    }

    findAllPagamentosPorClientes(queryOptions: QueryOptions): Observable<PagamentosPorClientes[]> {
        return this.httpClient.get<PagamentosPorClientes[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/pagamentos-por-clientes?${queryOptions.toQueryString()}`
        );
    }

    findAllParcelasPagasVencidas(queryOptions: QueryOptions): Observable<ParcelasPagasVencidas[]> {
        return this.httpClient.get<ParcelasPagasVencidas[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/parcelas-pagas-vencidas?${queryOptions.toQueryString()}`
        );
    }

    findAllRotas(): Observable<string[]> {
        return this.httpClient.get<string[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/parcelas-pagas-vencidas/rotas`
        );
    }

    findAllPostos(): Observable<string[]> {
        return this.httpClient.get<string[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/parcelas-pagas-vencidas/postos`
        );
    }

    findAllRenovacaoCredito(queryOptions: QueryOptions): Observable<RenovacaoCredito> {
        return this.httpClient.get<RenovacaoCredito>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/renovacao-credito?${queryOptions.toQueryString(false)}`
        );
    }

    findAllRenovacaoEvolucaoMensal(queryOptions: QueryOptions): Observable<RenovacaoEvolucaoMensal[]> {
        return this.httpClient.get<RenovacaoEvolucaoMensal[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/renovacao-evolucao-mensal?${queryOptions.toQueryString()}`
        );
    }

    findAllRenovacaoPorEstado(queryOptions: QueryOptions): Observable<RenovacaoPorEstado[]> {
        return this.httpClient.get<RenovacaoPorEstado[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/renovacao-por-estado?${queryOptions.toQueryString()}`
        );
    }

    findAllRenovacaoRankingFrequencia(queryOptions: QueryOptions): Observable<RenovacaoRankingFrequencia[]> {
        return this.httpClient.get<RenovacaoRankingFrequencia[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/renovacao-ranking-frequencia?${queryOptions.toQueryString()}`
        );
    }

    findAllRenovacaoClientesNaoRenovaram(queryOptions: QueryOptions): Observable<RenovacaoClientesNaoRenovaram[]> {
        return this.httpClient.get<RenovacaoClientesNaoRenovaram[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/renovacao-clientes-nao-renovaram?${queryOptions.toQueryString()}`
        );
    }

    findAllRenovacaoAptos(queryOptions: QueryOptions): Observable<RenovacaoAptos[]> {
        return this.httpClient.get<RenovacaoAptos[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/renovacao-aptos?${queryOptions.toQueryString()}`
        );
    }

    findAllRenovacaoComparativoStatus(): Observable<RenovacaoComparativoStatus[]> {
        return this.httpClient.get<RenovacaoComparativoStatus[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/renovacao-comparativo-status`
        );
    }

    findAllRenovacaoComparativoStatusFiltrado(queryOptions: QueryOptions): Observable<RenovacaoComparativoStatus[]> {
        return this.httpClient.get<RenovacaoComparativoStatus[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/renovacao-comparativo-status-filtrado?${queryOptions.toQueryString()}`
        );
    }

    findAllRenovacaoContatados(queryOptions: QueryOptions): Observable<RenovacaoContatados[]> {
        return this.httpClient.get<RenovacaoContatados[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/renovacao-contatados?${queryOptions.toQueryString()}`
        );
    }

    findAllRenovacaoEmNegociacao(queryOptions: QueryOptions): Observable<RenovacaoEmNegociacao[]> {
        return this.httpClient.get<RenovacaoEmNegociacao[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/renovacao-em-negociacao?${queryOptions.toQueryString()}`
        );
    }

    findAllCrescimentoBaseClientes(queryOptions: QueryOptions): Observable<CrescimentoBaseClientes[]> {
        return this.httpClient.get<CrescimentoBaseClientes[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/crescimento-base-clientes?${queryOptions.toQueryString(false)}`
        );
    }

    findCrescimentoBaseClientesKpis(): Observable<CrescimentoBaseClientesKpis> {
        return this.httpClient.get<CrescimentoBaseClientesKpis>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/crescimento-base-clientes-kpis`
        );
    }

    findCrescimentoBaseClientesSegmentos(): Observable<string[]> {
        return this.httpClient.get<string[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/crescimento-base-clientes-segmentos`
        );
    }

    findCrescimentoBaseClientesConsultores(): Observable<string[]> {
        return this.httpClient.get<string[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/crescimento-base-clientes-consultores`
        );
    }

    findCrescimentoBaseClientesCidades(): Observable<CrescimentoBaseClientesCidade[]> {
        return this.httpClient.get<CrescimentoBaseClientesCidade[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/crescimento-base-clientes-cidades`
        );
    }

    findCrescimentoBaseClientesDistribuicaoSegmento(): Observable<CrescimentoBaseClientesDistribuicaoSegmento[]> {
        return this.httpClient.get<CrescimentoBaseClientesDistribuicaoSegmento[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/crescimento-base-clientes-distribuicao-segmento`
        );
    }

    findCrescimentoBaseClientesPrimeiraOperacao(queryOptions: QueryOptions): Observable<CrescimentoBaseClientesPrimeiraOperacao[]> {
        return this.httpClient.get<CrescimentoBaseClientesPrimeiraOperacao[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/crescimento-base-clientes-primeira-operacao?${queryOptions.toQueryString(false)}`
        );
    }

    findCrescimentoBaseClientesInativosBloqueados(queryOptions: QueryOptions): Observable<CrescimentoBaseClientesInativoBloqueado[]> {
        return this.httpClient.get<CrescimentoBaseClientesInativoBloqueado[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/crescimento-base-clientes-inativos-bloqueados?${queryOptions.toQueryString(false)}`
        );
    }

    findAllVolumeCreditoMensal(queryOptions: QueryOptions): Observable<VolumeCreditoMensal[]> {
        return this.httpClient.get<VolumeCreditoMensal[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/volume-credito-mensal?${queryOptions.toQueryString()}`
        );
    }

    findAllComparativosHistoricos(queryOptions: QueryOptions): Observable<ComparativosHistoricos[]> {
        return this.httpClient.get<ComparativosHistoricos[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/comparativos-historicos?${queryOptions.toQueryString()}`
        );
    }

    findAllNovatosCobrancasRenovacoes(queryOptions: QueryOptions): Observable<NovatosCobrancasRenovacoes[]> {
        return this.httpClient.get<NovatosCobrancasRenovacoes[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/novatos-cobrancas-renovacoes?${queryOptions.toQueryString()}`
        );
    }

    findAllPostosNovatosCobrancasRenovacoes(): Observable<string[]> {
        return this.httpClient.get<string[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/novatos-cobrancas-renovacoes/postos`
        );
    }

    findAllRotasNovatosCobrancasRenovacoes(): Observable<string[]> {
        return this.httpClient.get<string[]>(
            `${WEB_API}/${NovoDashboardService.RESOURCE}/novatos-cobrancas-renovacoes/rotas`
        );
    }
}
